import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Layout from "../components/Layout";
import StepCard from "../components/StepCard";
import { api } from "../lib/api";
import { STEPS } from "../data/courseData";

export default function Journey() {
  const [progress, setProgress] = useState([]);

  useEffect(() => {
    api.get("/step-progress").then((r) => setProgress(r.data));
  }, []);

  const byStep = Object.fromEntries(progress.map((p) => [p.step, p]));

  return (
    <Layout>
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <div className="bps-eyebrow">The 4-Week Program</div>
        <h1 className="font-display text-3xl font-light tracking-tighter mt-1">Your Journey</h1>
        <p className="text-sm text-[#9AAEC6] mt-2">Each week contains four practices. Move slowly. Each week unlocks the next.</p>

        <div className="mt-6 space-y-4" data-testid="journey-list">
          {STEPS.map((s) => {
            const prev = s.step > 1 ? byStep[s.step - 1] : null;
            const previousComplete = s.step === 1 ? true : !!prev?.is_complete;
            return (
              <StepCard
                key={s.step}
                step={s}
                progress={{ ...(byStep[s.step] || {}), previousComplete }}
              />
            );
          })}
        </div>
      </motion.div>
    </Layout>
  );
}
